/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JobId } from "../../commons/types/JobId";
export const MappingFromPreprocessingJobConfig = core.serialization.object({
    proposal: core.serialization.any(),
    mappingJobId: JobId,
});
